import global_axios from './interaccionapi';

export const obtenerParametros = (tipo) =>{
    return new Promise((resolve, reject) => {
        global_axios.get('/parametros/' + tipo)
	    .then((response)=>{
            resolve(response.data);
        })
        .catch((err)=>{
            reject('Error al cargar datos de parámetros desde API: ' + err);
        });
    });
}

export const obtenerSecuencial = (codigo) =>{
    return new Promise((resolve, reject) => {
        global_axios.get('/secuenciales/' + codigo)
	    .then((response)=>{
            resolve(response.data);
        })
        .catch((err)=>{
            reject('Error al cargar datos de secuencial desde API: ' + err);
        });
    });
}